import fetchWrapper from '@http/fetchWrapper';
import type { I18nPostBody, I18nTranslatePostBody } from '@eye-able/types';
import { useMutation } from '@tanstack/react-query';
import { api } from '@http/constants';

export const useTranslationActions = () => {
  const saveAction = useMutation({
    mutationFn: (body: I18nPostBody) =>
      fetchWrapper.post(api.i18n, body) as Promise<void>,
  });

  const translateAction = useMutation({
    mutationFn: (body: I18nTranslatePostBody) =>
      fetchWrapper.post(api.i18nTranslate, body) as Promise<
        Record<string, string>
      >,
  });

  const flushCacheAction = useMutation({
    mutationFn: (version: string) =>
      fetchWrapper.delete(
        'https://apiv3amswswtgou9-api-ams.functions.fnc.nl-ams.scw.cloud/api/i18n/cache',
        { version },
      ) as Promise<void>,
  });

  return {
    saveAction,
    translateAction,
    flushCacheAction,
  };
};
